import React, { Component } from 'react'
import Button from "../../components/Button"
import { Link } from "react-router-dom"
import './css/mailing.css'

class mailing extends Component {
    render() {
        return (
            <div className="mailing">
                <div className="mailingfolder">
                    <div className="mailingfield">
                        <div className="mailingfieldtext">
                            <h1>DON’T BE LEFT OUT ON OUR NEW UPDATES FOR WEBINARS, VIDEOS, SEMINARS, EVENTS, ETC. SUBSCRIBE TO OUR MAILING LIST.</h1>
                        </div>

                        <div className="mailingfieldput">
                            <div className="inp">
                                <input placeholder="Enter your email address" type="email"/>
                            </div>
                            <div className="button">
                                <Link to="/">
                                    <Button className="sub-button">Subscribe</Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        )
    }
}

export default mailing;